export default __webpack_public_path__ + "static/media/001-air conditioner.b78c8e6a.svg";